import {
    type NetworkStatus,
    NetworkStatusDisplayTextMap,
    NetworkStatuses,
} from '@strata/constants';
import { StatusIndicator } from '@strata/react-status-indicators';

const getStatus = (networkStatus: NetworkStatus) =>
    networkStatus === NetworkStatuses.ACTIVE
        ? StatusIndicator.Status.IN_PROGRESS
        : StatusIndicator.Status.DEFAULT;

interface NetworkStatusIndicatorProps {
    networkStatus: NetworkStatus;
}

export const NetworkStatusIndicator = ({ networkStatus }: NetworkStatusIndicatorProps) => (
    <StatusIndicator
        status={getStatus(networkStatus)}
        message={NetworkStatusDisplayTextMap[networkStatus]}
    />
);
